/**
 * Access-token storage — IN MEMORY ONLY. Never localStorage / sessionStorage.
 * On page reload, the refresh cookie (HttpOnly) is used to mint a new access token.
 */
let accessToken: string | null = null;
let expiresAt = 0;

export function setAccessToken(token: string, ttlSeconds: number): void {
  accessToken = token;
  expiresAt = Date.now() + ttlSeconds * 1000;
}

export function getAccessToken(): string | null {
  if (!accessToken || Date.now() >= expiresAt - 5_000) return null;
  return accessToken;
}

export function clearAccessToken(): void {
  accessToken = null;
  expiresAt = 0;
}

/** Read CSRF token from cookie (set by auth-service on login/refresh). */
export function getCsrfToken(): string | null {
  const m = document.cookie.match(/(?:^|; )__Host-kidzio_csrf=([^;]+)/);
  return m ? decodeURIComponent(m[1]!) : null;
}
